import { frontendURL } from '../../../helper/URLHelper';

const PipelineKanban = () => import('./pages/PipelineKanban.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pipeline'),
    name: 'pipeline_kanban',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: PipelineKanban,
  },
];
